import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { register, load, getInstances } from '@shopify/theme-sections';
import * as Helpers from '../utilities/helpers';
Avatar.theme = Avatar.theme || {};
Avatar.theme.sections = Avatar.theme.sections || {};
var sectionName = 'video';

Avatar.theme.sections.Video = function Video() {
  var selectors = {
    section: '[data-section-type="video"]',
    video: '.video',
    videoWrapper: '.video-section-wrapper',
    playVideoBtn: '.video-control__play',
    closeVideoBtn: '.video-control__close-wrapper',
    pauseVideoBtn: '.video__pause',
    pauseVideoStop: '.video__pause-stop',
    pauseVideoResume: '.video__pause-resume',
    videoImage: '.video__image',
    fallbackText: '.sr-only'
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    backgroundVideoWrapper: 'video-background-wrapper',
    videoWithImage: 'video--image_with_play',
    backgroundVideo: 'video--background',
    userPaused: 'is-paused',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay',
    wrapperMinHeight: 'video-section-wrapper--min-height'
  };
  register(sectionName, {
    onLoad: function onLoad() {
      var container = this.container;
      this.video = this.container.querySelector(selectors.video);
      this.eventHandlers = {};
      this.autoplayCheckComplete = false;
      this.playOnClickChecked = false;
      this.playOnClick = false;
      this.youtubeLoaded = window.youtubeLoaded;
      this.vimeoLoaded = window.vimeoLoaded;
      this.source = this.video.dataset.source;
      this.coverImage = this.video.dataset.coverImage;
      Avatar.theme.videos = Avatar.theme.videos || {};
      Avatar.theme.videoPlayers = Avatar.theme.videoPlayers || [];
      Avatar.theme.videoSources = Avatar.theme.videoSources || [];
      this.videoOptions = {
        ratio: 16 / 9,
        scrollAnimationDuration: 400,
        playerVars: {
          // eslint-disable-next-line camelcase
          iv_load_policy: 3,
          modestbranding: 1,
          autoplay: 0,
          controls: 0,
          wmode: 'opaque',
          branding: 0,
          autohide: 0,
          rel: 0
        },
        events: {
          onReady: this.onPlayerReady.bind(this),
          onStateChange: this.onPlayerChange.bind(this)
        }
      };

      if (this.video) {
        this.init(this.video); // this.editorLoadVideo(this.video.id);

        Avatar.theme.videoSources.push(this.source);
      }
    },
    init: function init(video) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var source, tag, firstScriptTag, _tag, _firstScriptTag;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (video) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                Avatar.theme.videos[video.id] = {
                  id: video.id,
                  videoId: video.dataset.id,
                  type: video.dataset.type,
                  status: video.dataset.type === 'image_with_play' ? 'closed' : 'background',
                  // closed, open, background
                  video: video,
                  videoWrapper: video.closest(selectors.videoWrapper),
                  section: video.closest(selectors.section),
                  controls: video.dataset.type === 'background' ? 0 : 1,
                  width: video.dataset.width,
                  source: video.dataset.source
                };
                source = video.dataset.source;

                if (source === 'youtube' && !window.youtubeLoaded) {
                  // This code loads the IFrame Player API code asynchronously.
                  tag = document.createElement('script');
                  tag.src = 'https://www.youtube.com/iframe_api';
                  firstScriptTag = document.getElementsByTagName('script')[0];
                  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                }

                if (source === 'vimeo' && !window.vimeoLoaded) {
                  _tag = document.createElement('script');
                  _tag.src = 'https://player.vimeo.com/api/player.js';
                  _firstScriptTag = document.getElementsByTagName('script')[0];

                  _firstScriptTag.parentNode.insertBefore(_tag, _firstScriptTag);
                }

                if (source === 'vimeo') {
                  _this.checkVimeoReady().then(function () {
                    _this.loadVideos();

                    _this.onVimeoReady(video);
                  }).catch(function (err) {
                    console.log(err);
                  });
                }

                if (source === 'youtube') {
                  window.YTQueue.queueItem(function () {
                    _this.loadVideos();
                  });
                }

                _this.playOnClickCheck();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    checkVimeoReady: function checkVimeoReady() {
      var vimeoPromise = new Promise(function (resolve, reject) {
        var interval = setInterval(function () {
          if (Avatar.theme.videoSources.includes('youtube')) {
            if (typeof Vimeo === 'undefined' || !YT.loaded) {
              return;
            }
          } else if (typeof Vimeo === 'undefined') {
            return;
          }

          clearInterval(interval);
          clearTimeout(timeout);
          window.vimeoLoaded = true;
          resolve();
        }, 500);
        var timeout = setTimeout(function () {
          clearInterval(interval);
          reject();
        }, 4000);
      });
      return vimeoPromise;
    },
    customPlayVideo: function customPlayVideo(playerId) {
      // Make sure we have carried out the playOnClick check first
      if (!this.playOnClickChecked && !this.playOnClick) {
        return;
      }

      if (playerId && typeof Avatar.theme.videoPlayers[playerId].playVideo === 'function') {
        this.privatePlayVideo(playerId);
      }
    },
    pauseVideo: function pauseVideo(playerId) {
      if (Avatar.theme.videoPlayers[playerId] && typeof Avatar.theme.videoPlayers[playerId].pauseVideo === 'function') {
        Avatar.theme.videoPlayers[playerId].pauseVideo();
      } else if (Avatar.theme.videoPlayers[playerId] && typeof Avatar.theme.videoPlayers[playerId].pause === 'function') {
        Avatar.theme.videoPlayers[playerId].pause();
      }
    },
    loadVideos: function loadVideos() {
      // eslint-disable-next-line no-restricted-syntax
      for (var key in Avatar.theme.videos) {
        if (Avatar.theme.videos.hasOwnProperty(key)) {
          if (Avatar.theme.videos[key].source === 'youtube' && !Avatar.theme.videos[key].init) {
            this.createPlayer(key, 'youtube');
          }

          if (Avatar.theme.videos[key].source === 'vimeo' && !Avatar.theme.videos[key].init) {
            this.createPlayer(key, 'vimeo');
          }
        }
      }

      this.initEvents();
    },
    editorLoadVideo: function editorLoadVideo(key) {
      if (Shopify.designMode) {
        if (this.source === 'youtube' && !window.youtubeLoaded) return;
        if (this.source === 'vimeo' && !window.vimeoLoaded) return; // this.createPlayer(key);

        this.initEvents();
      }
    },
    privatePlayVideo: function privatePlayVideo(id, clicked) {
      var videoData = Avatar.theme.videos[id];
      var player = Avatar.theme.videoPlayers[id];
      var videoWrapper = videoData.videoWrapper,
          source = videoData.source;

      if (this.playOnClick) {
        // playOnClick means we are probably on mobile (no autoplay).
        // setAsPlaying will show the iframe, requiring another click
        // to play the video.
        this.setAsPlaying(videoData);
      } else if (clicked || this.autoplayCheckComplete) {
        // Play if autoplay is available or clicked to play
        videoWrapper.classList.remove(classes.loading);
        this.setAsPlaying(videoData);
        setTimeout(function () {
          source === 'youtube' ? player.playVideo() : player.play();
        }, this.videoOptions.scrollAnimationDuration);
      } else {
        source === 'youtube' ? player.playVideo() : player.play();
      }
    },
    setAutoplaySupport: function setAutoplaySupport(supported) {
      var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
      document.documentElement.classList.remove(classes.supportsAutoplay, classes.supportsNoAutoplay);
      document.documentElement.classList.add(supportClass);

      if (!supported) {
        this.playOnClick = true;
      }

      this.autoplayCheckComplete = true;
    },
    playOnClickCheck: function playOnClickCheck() {
      if (this.playOnClickChecked) {
        return;
      }

      if (this.isMobile()) {
        this.playOnClick = false;
      }

      if (this.playOnClick) {
        // No need to also do the autoplay check
        this.setAutoplaySupport(false);
      }

      this.playOnClickChecked = true;
    },
    // The API will call this function when each video player is ready
    onPlayerReady: function onPlayerReady(evt) {
      evt.target.setPlaybackQuality('hd1080');
      var videoData = this.getVideoOptions(evt);
      var videoTitle = evt.target.getVideoData().title;
      this.playOnClickCheck(); // Prevent tabbing through YouTube player controls until visible

      document.getElementById(videoData.id).setAttribute('tabindex', '-1');
      this.sizeBackgroundVideos();
      this.setButtonLabels(videoData.videoWrapper, videoTitle); // Customize based on options from the video ID

      if (videoData.type === 'background') {
        if (this.isMobile() === false) {
          evt.target.mute();
          this.privatePlayVideo(videoData.id);
        }
      }

      videoData.videoWrapper.classList.add(classes.loaded);
    },
    onVimeoReady: function onVimeoReady(video) {
      var _this2 = this;

      this.playOnClickCheck();
      var videoData = Avatar.theme.videos[video.id];
      videoData.videoWrapper.classList.add(classes.loaded);
      document.getElementById(videoData.id).setAttribute('tabindex', '-1');
      this.sizeBackgroundVideos();
      Avatar.theme.videoPlayers[videoData.id].getVideoTitle().then(function (title) {
        _this2.setButtonLabels(videoData.videoWrapper, title);
      });

      if (videoData.type === 'background') {
        if (!this.isMobile()) {
          this.privatePlayVideo(videoData.id);
          this.setAutoplaySupport(true);
        }
      }
    },
    onPlayerChange: function onPlayerChange(evt) {
      var _this3 = this;

      var videoData = this.getVideoOptions(evt);

      if (videoData.status === 'background' && !this.isMobile() && !this.autoplayCheckComplete && (evt.data === YT.PlayerState.PLAYING || evt.data === YT.PlayerState.BUFFERING)) {
        this.setAutoplaySupport(true);
        this.autoplayCheckComplete = true;
        videoData.videoWrapper.classList.remove(classes.loading);
      } // eslint-disable-next-line default-case


      switch (evt.data) {
        case YT.PlayerState.ENDED:
          this.setAsFinished(videoData);
          break;

        case YT.PlayerState.PAUSED:
          // Seeking on a YouTube video also fires a PAUSED state change,
          // checking the state after a delay prevents us pausing the video when
          // the user is seeking instead of pausing
          setTimeout(function () {
            if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
              if (_this3.isMobile()) return;

              _this3.setAsPaused(videoData);
            }
          }, 200);
          break;
      }
    },
    setAsFinished: function setAsFinished(videoData) {
      // eslint-disable-next-line default-case
      switch (videoData.type) {
        case 'background':
          Avatar.theme.videoPlayers[videoData.id].seekTo(0);
          break;

        case 'image_with_play':
          this.closeVideo(videoData.id);
          this.toggleExpandVideo(videoData.id, false);
          break;
      }
    },
    setAsPlaying: function setAsPlaying(videoData) {
      var videoWrapper = videoData.videoWrapper;
      var pauseButton = videoWrapper.querySelector(selectors.pauseVideoBtn);
      videoWrapper.classList.remove(classes.loading);

      if (pauseButton.classList.contains(classes.userPaused)) {
        pauseButton.classList.remove(classes.userPaused);
      } // Do not change element visibility if it is a background video


      if (videoData.status === 'background') {
        return;
      }

      document.getElementById(videoData.id).setAttribute('tabindex', '0');

      if (videoData.type === 'image_with_play') {
        videoWrapper.classList.remove(classes.paused);
        setTimeout(function () {
          videoWrapper.classList.add(classes.playing);
        }, this.videoOptions.scrollAnimationDuration + 100);
      } // Update focus to the close button so we stay within the video wrapper,
      // allowing time for the scroll animation


      setTimeout(function () {
        videoWrapper.querySelector(selectors.closeVideoBtn).focus();
      }, this.videoOptions.scrollAnimationDuration);
    },
    setAsPaused: function setAsPaused(videoData) {
      var videoWrapper = videoData.videoWrapper; // YT's events fire after our click event. This status flag ensures
      // we don't interact with a closed or background video.

      if (videoData.type === 'image_with_play') {
        if (videoData.status === 'closed') {
          videoWrapper.classList.remove(classes.paused);
        } else {
          videoWrapper.classList.add(classes.paused);
        }
      }

      videoWrapper.classList.remove(classes.playing);
    },
    closeVideo: function closeVideo(playerId) {
      var videoData = Avatar.theme.videos[playerId];
      var videoWrapper = videoData.videoWrapper,
          source = videoData.source;
      document.getElementById(videoData.id).setAttribute('tabindex', '-1');
      videoData.status = 'closed'; // eslint-disable-next-line default-case

      switch (videoData.type) {
        case 'image_with_play':
          if (source === 'youtube') {
            Avatar.theme.videoPlayers[playerId].stopVideo();
          } else {
            Avatar.theme.videoPlayers[playerId].pause();
            Avatar.theme.videoPlayers[playerId].setCurrentTime(0);
          }

          this.setAsPaused(videoData); // in case the video is already paused

          break;

        case 'background':
          if (source === 'youtube') {
            Avatar.theme.videoPlayers[playerId].mute();
          } else {
            Avatar.theme.videoPlayers[playerId].setVolume(0);
          }

          this.setBackgroundVideo(playerId);
          break;
      }

      videoWrapper.classList.remove(classes.paused, classes.playing);
    },
    getVideoOptions: function getVideoOptions(evt) {
      var _evt$target$getIframe = evt.target.getIframe(),
          id = _evt$target$getIframe.id;

      return Avatar.theme.videos[id];
    },
    toggleExpandVideo: function toggleExpandVideo(playerId, expand) {
      var video = Avatar.theme.videos[playerId];
      var elementTop = video.videoWrapper.getBoundingClientRect().top + window.pageYOffset;
      var playButton = video.videoWrapper.querySelector(selectors.playVideoBtn);
      var offset = 0;
      var newHeight = 0; // if (this.isMobile()) {
      //   video.videoWrapper.parentElement.classList.toggle(`${video.width}`, !expand);
      // }

      if (expand) {
        if (this.isMobile()) {
          newHeight = window.innerWidth / this.videoOptions.ratio;
        } else {
          newHeight = video.videoWrapper.offsetWidth / this.videoOptions.ratio;
        }

        offset = (window.innerHeight - newHeight) / 2;
        video.videoWrapper.style.height = "".concat(video.videoWrapper.getBoundingClientRect().height, "px");
        video.videoWrapper.classList.remove(classes.wrapperMinHeight);
        video.videoWrapper.style.height = "".concat(newHeight, "px"); // Animate doesn't work in mobile editor, so we don't use it

        if (!(this.isMobile() && Shopify.designMode)) {
          var scrollBehavior = document.documentElement.style.scrollBehavior;
          document.documentElement.style.scrollBehavior = 'smooth';
          window.scrollTo({
            top: elementTop - offset
          });
          document.documentElement.style.scrollBehavior = scrollBehavior;
        }
      } else {
        if (this.isMobile()) {
          newHeight = video.videoWrapper.dataset.mobileHeight;
        } else {
          newHeight = video.videoWrapper.dataset.desktopHeight;
        }

        video.videoWrapper.style.height = "".concat(newHeight, "px");
        setTimeout(function () {
          video.videoWrapper.classList.add(classes.wrapperMinHeight);
        }, 600); // Set focus on play button, but don't scroll page

        var x = window.scrollX;
        var y = window.scrollY;
        playButton.focus();
        window.scrollTo(x, y);
      }
    },
    togglePause: function togglePause(playerId) {
      var pauseButton = Avatar.theme.videos[playerId].videoWrapper.querySelector(selectors.pauseVideoBtn);
      var paused = pauseButton.classList.contains(classes.userPaused);

      if (paused) {
        pauseButton.classList.remove(classes.userPaused);
        this.customPlayVideo(playerId);
        this.privatePlayVideo(playerId);
      } else {
        pauseButton.classList.add(classes.userPaused);
        this.pauseVideo(playerId);
      }

      pauseButton.setAttribute('aria-pressed', !paused);
    },
    startVideoOnClick: function startVideoOnClick(playerId) {
      var video = Avatar.theme.videos[playerId]; // add loading class to wrapper

      video.videoWrapper.classList.add(classes.loading); // Explicity set the video wrapper height (needed for height transition)

      video.videoWrapper.style.height = "".concat(video.videoWrapper.offsetHeight, "px");
      video.status = 'open'; // eslint-disable-next-line default-case

      switch (video.type) {
        case 'image_with_play':
          this.privatePlayVideo(playerId, true);
          break;

        case 'background':
          this.unsetBackgroundVideo(playerId, video);

          if (video.source === 'youtube') {
            Avatar.theme.videoPlayers[playerId].unMute();
          } else if (video.source === 'vimeo') {
            Avatar.theme.videoPlayers[playerId].setVolume(1);
            Avatar.theme.videoPlayers[playerId].setLoop(false);
          }

          this.privatePlayVideo(playerId, true);
          break;
      }

      this.toggleExpandVideo(playerId, true); // esc to close video player

      document.addEventListener('keydown', this.handleVideoPlayerKeydown);
    },
    handleVideoPlayerKeydown: function handleVideoPlayerKeydown(evt) {
      var playerId = document.activeElement.dataset.controls;

      if (evt.keyCode !== Avatar.theme.keyboardKeys.ESCAPE || !playerId) {
        return;
      }

      this.closeVideo(playerId);
      this.toggleExpandVideo(playerId, false);
    },
    sizeBackgroundVideos: function sizeBackgroundVideos() {
      var _this4 = this;

      var backgroundVideos = document.querySelectorAll(".".concat(classes.backgroundVideo));
      backgroundVideos.forEach(function (el) {
        _this4.sizeBackgroundVideo(el);
      });
    },
    sizeBackgroundVideo: function sizeBackgroundVideo(videoPlayer) {
      if (this.source === 'youtube' && !window.youtubeLoaded) return;
      if (this.source === 'vimeo' && !window.vimeoLoaded) return;

      if (this.isMobile()) {
        videoPlayer.style.cssText = null;
      } else {
        var videoWrapper = videoPlayer.closest(selectors.videoWrapper);
        var videoWidth = videoWrapper.clientWidth;
        var playerWidth = videoPlayer.clientWidth;
        var desktopHeight = videoWrapper.dataset.desktopHeight; // when screen aspect ratio differs from video, video must center and underlay one dimension

        if (videoWidth / this.videoOptions.ratio < desktopHeight) {
          playerWidth = Math.ceil(desktopHeight * this.videoOptions.ratio); // get new player width

          var styles = "width: ".concat(playerWidth, "px; height: ").concat(desktopHeight, "px; left: ").concat((videoWidth - playerWidth) / 2, "px; top: 0;");
          videoPlayer.style.cssText = styles;
        } else {
          // new video width < window width (gap to right)
          desktopHeight = Math.ceil(videoWidth / this.videoOptions.ratio); // get new player height

          var styles2 = "width: ".concat(videoWidth, "px; height: ").concat(desktopHeight, "px; top: ").concat((desktopHeight - desktopHeight) / 2, "px; left: 0;"); // player height is greater, offset top; reset left

          videoPlayer.style.cssText = styles2;
        } // theme.Helpers.prepareTransition(videoPlayer);


        videoWrapper.classList.add(classes.loaded);
      }
    },
    unsetBackgroundVideo: function unsetBackgroundVideo(playerId) {
      // Switch the background video to a chrome-only player once played
      var player = document.getElementById(playerId);
      player.classList.remove(classes.backgroundVideo);
      player.classList.add(classes.videoWithImage);
      setTimeout(function () {
        document.getElementById(playerId).style.cssText = null;
      }, 600);
      Avatar.theme.videos[playerId].videoWrapper.classList.remove(classes.backgroundVideoWrapper);
      Avatar.theme.videos[playerId].videoWrapper.classList.add(classes.playing);
      Avatar.theme.videos[playerId].status = 'open';
    },
    setBackgroundVideo: function setBackgroundVideo(playerId) {
      var player = document.getElementById(playerId);
      player.classList.remove(classes.videoWithImage);
      player.classList.add(classes.backgroundVideo);
      Avatar.theme.videos[playerId].videoWrapper.classList.add(classes.backgroundVideoWrapper);
      Avatar.theme.videos[playerId].status = 'background';
      this.sizeBackgroundVideo(player);
    },
    isMobile: function isMobile() {
      return window.matchMedia(Avatar.theme.settings.mediaQuery.small).matches;
    },
    handleWindowResize: function handleWindowResize() {
      if (this.source === 'youtube' && !window.youtubeLoaded) return;
      if (this.source === 'vimeo' && !window.vimeoLoaded) return;
      var key;
      var fullscreen = window.innerHeight === screen.height;
      this.sizeBackgroundVideos();

      if (this.isMobile()) {
        // eslint-disable-next-line no-restricted-syntax
        for (key in Avatar.theme.videos) {
          if (Avatar.theme.videos.hasOwnProperty(key)) {
            if (Avatar.theme.videos[key].videoWrapper.classList.contains(classes.playing)) {
              if (!fullscreen) {
                this.pauseVideo(key);
                this.setAsPaused(Avatar.theme.videos[key]);
              }
            }

            Avatar.theme.videos[key].videoWrapper.style.height = "\n              ".concat(document.documentElement.clientWidth / this.videoOptions.ratio, "px\n            ");
          }
        }

        this.setAutoplaySupport(false);
      } else {
        this.setAutoplaySupport(true); // eslint-disable-next-line no-restricted-syntax

        for (key in Avatar.theme.videos) {
          var videosWithImage = Avatar.theme.videos[key].videoWrapper.querySelectorAll(".".concat(classes.videoWithImage));
          this.closeVideo(key);
          this.toggleExpandVideo(key, false);

          if (videosWithImage.length) {
            continue;
          }

          if (Avatar.theme.videos[key].source === 'youtube') {
            Avatar.theme.videoPlayers[key].playVideo();
          } else {
            Avatar.theme.videoPlayers[key].play();
          }

          this.setAsPlaying(Avatar.theme.videos[key]);
        }
      }

      ;
    },
    handleWindowScroll: function handleWindowScroll() {
      if (this.source === 'youtube' && !window.youtubeLoaded) return;
      if (this.source === 'vimeo' && !window.vimeoLoaded) return; // eslint-disable-next-line no-restricted-syntax

      for (var key in Avatar.theme.videos) {
        if (Avatar.theme.videos.hasOwnProperty(key)) {
          var videoWrapper = Avatar.theme.videos[key].videoWrapper;
          var condition = videoWrapper.getBoundingClientRect().top + window.pageYOffset + videoWrapper.offsetHeight * 0.85 < window.pageYOffset || videoWrapper.getBoundingClientRect().top + window.pageYOffset + videoWrapper.offsetHeight * 0.15 > window.pageYOffset + window.innerHeight; // Close the video if more than 75% of it is scrolled out of view

          if (videoWrapper.classList.contains(classes.playing)) {
            if (!condition) return;
            this.closeVideo(key);
            this.toggleExpandVideo(key, false);
          }
        }
      }
    },
    initEvents: function initEvents() {
      var _this5 = this;

      var playVideoBtns = this.container.querySelectorAll(selectors.playVideoBtn);
      var closeVideoBtns = this.container.querySelectorAll(selectors.closeVideoBtn);
      var pauseVideoBtns = this.container.querySelectorAll(selectors.pauseVideoBtn);
      playVideoBtns.forEach(function (btn) {
        btn.addEventListener('click', function (evt) {
          var playerId = evt.currentTarget.dataset.controls;

          _this5.startVideoOnClick(playerId);
        });
      });
      closeVideoBtns.forEach(function (btn) {
        btn.addEventListener('click', function (evt) {
          var playerId = evt.currentTarget.dataset.controls;
          evt.currentTarget.blur();

          _this5.closeVideo(playerId);

          _this5.toggleExpandVideo(playerId, false);
        });
      });
      pauseVideoBtns.forEach(function (btn) {
        btn.addEventListener('click', function (evt) {
          var playerId = evt.currentTarget.dataset.controls;

          _this5.togglePause(playerId);
        });
      }); // Listen to resize to keep a background-size:cover-like layout

      this.eventHandlers.handleWindowResize = Helpers.debounce(this.handleWindowResize.bind(this), 200);
      window.addEventListener('resize', this.eventHandlers.handleWindowResize);
      this.eventHandlers.handleWindowScroll = Helpers.debounce(this.handleWindowScroll.bind(this), 50);
      window.addEventListener('scroll', this.eventHandlers.handleWindowScroll);
    },
    createPlayer: function createPlayer(key, source) {
      var args = Object.assign(this.videoOptions, Avatar.theme.videos[key]);
      args.playerVars.controls = args.controls;

      if (source === 'youtube') {
        Avatar.theme.videoPlayers[key] = new YT.Player(key, args);
        Avatar.theme.videos[key].init = true;
      }

      if (source === 'vimeo') {
        var vimeoOptions = {
          id: args.videoId,
          muted: args.type === 'background',
          loop: args.type === 'background'
        };
        Avatar.theme.videoPlayers[key] = new Vimeo.Player(key, vimeoOptions);
        Avatar.theme.videos[key].init = true;
      }
    },
    removeEvents: function removeEvents() {
      var _this6 = this;

      document.removeEventListener('keydown', this.handleVideoPlayerKeydown);
      window.removeEventListener('resize', this.eventHandlers.handleWindowResize);
      window.removeEventListener('scroll', this.eventHandlers.handleWindowScroll);
      var playVideoBtns = this.container.querySelectorAll(selectors.playVideoBtn);
      var closeVideoBtns = this.container.querySelectorAll(selectors.closeVideoBtn);
      var pauseVideoBtns = this.container.querySelectorAll(selectors.pauseVideoBtn);
      playVideoBtns.forEach(function (btn) {
        btn.removeEventListener('click', function (evt) {
          var playerId = evt.currentTarget.dataset.controls;

          _this6.startVideoOnClick(playerId);
        });
      });
      closeVideoBtns.forEach(function (btn) {
        btn.removeEventListener('click', function (evt) {
          var playerId = evt.currentTarget.dataset.controls;
          evt.currentTarget.blur();

          _this6.closeVideo(playerId);

          _this6.toggleExpandVideo(playerId, false);
        });
      });
      pauseVideoBtns.forEach(function (btn) {
        btn.removeEventListener('click', function (evt) {
          var playerId = evt.currentTarget.dataset.controls;

          _this6.togglePause(playerId);
        });
      });
    },
    setButtonLabels: function setButtonLabels(videoWrapper, title) {
      var playButtons = videoWrapper.querySelectorAll(selectors.playVideoBtn);
      var closeButton = videoWrapper.querySelector(selectors.closeVideoBtn);
      var pauseButton = videoWrapper.querySelector(selectors.pauseVideoBtn);
      var closeButtonText = closeButton.querySelector(selectors.fallbackText);
      var pauseButtonStop = pauseButton.querySelector(selectors.pauseVideoStop);
      var pauseButtonStopText = pauseButtonStop.querySelector(selectors.fallbackText);
      var pauseButtonResume = pauseButton.querySelector(selectors.pauseVideoResume);
      var pauseButtonResumeText = pauseButtonResume.querySelector(selectors.fallbackText); // Insert the video title retrieved from YouTube into the instructional text
      // for each button

      playButtons.forEach(function (playButton) {
        var playButtonText = playButton.querySelector(selectors.fallbackText);
        playButtonText.textContent = playButtonText.textContent.replace('[video_title]', title);
      });
      closeButtonText.textContent = closeButtonText.textContent.replace('[video_title]', title);
      pauseButtonStopText.textContent = pauseButtonStopText.textContent.replace('[video_title]', title);
      pauseButtonResumeText.textContent = pauseButtonResumeText.textContent.replace('[video_title]', title);
    },
    onUnload: function onUnload() {
      this.removeEvents();
    }
  });
  load(sectionName);
  var instances = getInstances(sectionName);
  return instances;
}();